var _mask, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddToAddressbook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 11,
    height: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.821289 0H10.1208V10H0.821289V0Z",
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.821289 0H6.05226V1.66667H0.821289V0Z",
    fill: "#438DED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.821289 2.70833H6.05226V4.0625H10.1208V4.375H0.821289V2.70833Z",
    fill: "#438DED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.821289 5.625H10.1208V7.29167H0.821289V5.625Z",
    fill: "#438DED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.821289 8.33333H10.1208V10H0.821289V8.33333Z",
    fill: "#438DED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1134 1.26852H8.93372V0H7.90036V1.26852H6.7207V2.37972H7.90036V3.64835H8.93372V2.37972H10.1134V1.26852Z",
    fill: "#438DED"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddToAddressbook);
export default __webpack_public_path__ + "static/media/add-to-addressbook.4b1ff24b41243bf858828a6a41125065.svg";
export { ForwardRef as ReactComponent };